import { DataBundle } from "@intocare/datatypes/lib/bundle";
import { languageForLocale, SupportedLanguage, SupportedLocale } from "@intocare/datatypes/lib/i18n";
import { ValueSet } from "@intocare/datatypes/lib/value-set";

export interface CareTreeItemDto {
	name: Record<SupportedLanguage, string>;
	code: string;
	archived?: boolean;
	children?: CareTreeItemDto[];
}

const CARE_TREE_RECURSION_DEPTH_LIMIT = 20; // Seems to be TypeScript's default (20).

function careTreeItemsDtoToValueSetConcepts(
	context: { locale: SupportedLocale; filters?: { active?: true } },
	careTreeItems: CareTreeItemDto[],
	result: ValueSet["concept"][number][] = [],
	recursionDepth = 1,
): ValueSet["concept"][number][] {
	if (recursionDepth > CARE_TREE_RECURSION_DEPTH_LIMIT) {
		throw new Error("CareTree recursion depth exceeds the limit of 20!");
	}

	careTreeItems.forEach((careTreeItem) => {
		if (!careTreeItem.archived || !context.filters?.active) {
			result.push({
				coding: {
					code: careTreeItem.code,
					display: `${careTreeItem.name[languageForLocale(context.locale)]} (${careTreeItem.code})`,
				},
			});
		}

		if (careTreeItem.children) {
			careTreeItemsDtoToValueSetConcepts(context, careTreeItem.children, result, recursionDepth + 1);
		}
	});

	return result;
}

export const careTreeValueSetFor =
	(context: { locale: SupportedLocale; filters?: { active?: true } }) =>
	(careTreeBundle: DataBundle<CareTreeItemDto[]>): ValueSet => ({
		name: `${context.filters?.active ? "ACTIVE" : "ALL"}_CARE_TREE_ITEMS`,
		description: `${context.filters?.active ? "Active" : "All"} care-tree items as value
		 set`,
		system: "CARE_TREE_ITEMS",
		concept: careTreeItemsDtoToValueSetConcepts(context, careTreeBundle.data),
	});
